// Fichier généré automatiquement par le serveur admin - Ne pas modifier à la main
export default [
    {
        "src": "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/2.jpg",
        "title": "Bureau assis-debout - Hêtre massif",
        "tag": "Ce bureau a été conçu dans l’optique d’offrir un moyen simple et rapide de passer d’une position à l’autre.  Un bureau qui incarne l’élégance moderne avec ses lignes courbes et son design épuré. Ce meuble d’exception se distingue par ses contours fluide et son chanfrein progressif noir, qui ajoutent une touche de sophistication et de raffinement.",
        "images": [
            "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/2.jpg",
            "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/3.jpg",
            "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/4.jpg",
            "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/5.jpg",
            "/images/bureau-assis-debout---hêtre-massif-et-plateau-en-placage-de-chêne/5.mp4"
        ]
    },
    {
        "src": "/images/porte cannage et chene brun 1.png",
        "title": "Portes coulissantes - Chêne Brun & Cannage",
        "tag": "Cette paire de portes de placard est l’incarnation d’un luxe discret et texturé. Elles marient la chaleur naturelle du bois à une esthétique géométrique unique pour créer une séparation d’espace qui est en soi une œuvre d’art.",
        "images": [
            "/images/porte cannage et chene brun 1.png",
            "/images/portes-coulissantes---chêne-brun--cannage/2.png",
            "/images/portes-coulissantes---chêne-brun--cannage/3.jpg"
        ]
    },
    {
        "src": "/images/bibliotheque/bibliotheque_1.png",
        "title": "Agencement bibliothèque et portes en hêtre massif",
        "tag": "Cette bibliothèque et ces portes sur mesure associe la chaleur du hêtre massif à l'aspect brut et moderne d'une structure intégrée en béton. Ajustée au millimètre près pour épouser l'architecture de la pièce, elle propose de larges étagères aériennes et des rangements aux finitions soignées. Une création artisanale unique, conçue pour structurer l'espace tout en mettant en valeur vos livres et objets de décoration",
        "images": [
            "/images/bibliotheque/bibliotheque_1.png",
            "/images/bibliotheque/bibliotheque_2.png",
            "/images/agencement-bibliothèque-et-portes-en-hêtre-massif/3.png",
            "/images/agencement-bibliothèque-et-portes-en-hêtre-massif/4.png",
            "/images/agencement-bibliothèque-et-portes-en-hêtre-massif/5.png",
            "/images/agencement-bibliothèque-et-portes-en-hêtre-massif/6.png"
        ]
    },
    {
        "src": "/images/legumier 1.png",
        "title": "Légumier - Chataigner massif et cannage",
        "tag": "Ce légumier en châtaignier et cannage arbore une structure artisanale en bois brut de style buffet ou commode, doté de quatre tiroirs à façade ajourée favorisant une circulation optimale de l'air pour la conservation des fruits et légumes. Son design naturel et robuste est complété par des panneaux latéraux en cannage tissé, apportant une touche d'élégance rustique et fonctionnelle à n'importe quelle cuisine ou cellier.",
        "images": [
            "/images/legumier 1.png",
            "/images/légumier---chataigner-massif-et-cannage/2.png",
            "/images/légumier---chataigner-massif-et-cannage/3.png",
            "/images/légumier---chataigner-massif-et-cannage/4.png"
        ]
    },
    {
        "src": "/images/agencement salle de bain 3.png",
        "title": "Agencement sdb - Châtaignier Massif & Cannage",
        "tag": "Apportez une touche de douceur organique et de raffinement à votre intérieur avec nos façades de meubles confectionnées à la main. Mariage parfait entre tradition ébéniste et design contemporain, ces portes transforment n’importe quel caisson en une pièce maîtresse de caractère.",
        "images": [
            "/images/agencement salle de bain 3.png",
            "/images/agencement-sdb---châtaignier-massif--cannage/2.png",
            "/images/agencement-sdb---châtaignier-massif--cannage/3.png",
            "/images/agencement-sdb---châtaignier-massif--cannage/4.png"
        ]
    },
    {
        "src": "/images/porte cannage et chene clair 4.png",
        "title": "Portes coulissantes - Chêne et Canne de Rotin",
        "tag": "Apportez une touche de sérénité et de chaleur à votre intérieur avec nos portes de placard coulissantes. Inspirées par le design Japandi et le style bohème chic, ces portes transforment un simple espace de rangement en une véritable pièce maîtresse de votre décoration",
        "images": [
            "/images/porte cannage et chene clair 4.png",
            "/images/portes-coulissantes---chêne-et-canne-de-rotin/2.jpg",
            "/images/portes-coulissantes---chêne-et-canne-de-rotin/3.jpg",
            "/images/portes-coulissantes---chêne-et-canne-de-rotin/4.jpg"
        ]
    },
    {
        "src": "/images/claustra demi lune 2.jpg",
        "title": "Claustra demi-lune - Hêtre massif teinté",
        "tag": "Cette claustra demi-lune a été imaginée et réalisée sur mesure. Sa forme courbée adoucit la structure et apporte une touche de douceur et d’harmonie à l’ensemble de la pièce. Fabriquée en bois massif, elle allie chaleur naturelle et raffinement.",
        "images": [
            "/images/claustra demi lune 2.jpg",
            "/images/claustra-demi-lune---hêtre-massif-teinté/2.jpg"
        ]
    },
    {
        "src": "/images/Tensegrity table 1.jpg",
        "title": "Table basse suspendue - chêne massif, métal et verre",
        "tag": "Élégante et innovante, cette table basse suspendue joue avec les perceptions et défie les lois de la gravité en s’appuyant sur un ingénieux jeu de tensions. Son design aérien repose sur un subtil équilibre entre forces opposées, donnant l’illusion d’un plateau en lévitation. L’association du bois, de l’acier et du verre confère à cette pièce une esthétique à la fois moderne et intemporelle, où chaque matériau trouve sa place avec justesse.",
        "images": [
            "/images/Tensegrity table 1.jpg",
            "/images/table-basse-suspendue---chêne-massif-métal-et-verre/2.jpg"
        ]
    },
    {
        "src": "/images/Portes cluastra 2.jpg",
        "title": "Portes ajoutés type \"Claustra\" - Hêtre massif ",
        "tag": "Conçues en hêtre massif avec une structure de type claustra, ces portes de placard ajourées marient le bois naturel à une finition teintée plus sombre. Leur design unique, rythmé par des tasseaux verticaux et des traverses courbes, est complété par des poignées rondes en laiton pour une touche d'élégance contemporaine. Une solution sur mesure idéale pour ventiler discrètement les rangements tout en apportant une forte identité architecturale à l'espace.",
        "images": [
            "/images/Portes cluastra 2.jpg",
            "/images/portes-ajoutés-type-claustra---hêtre-massif-/2.jpg"
        ]
    },
    {
        "src": "/images/table couture 2.jpg",
        "title": "Table de Couture - Epicéa massif",
        "tag": "Le plateau en bois massif a été soigneusement fabriqué pour offrir une surface lisse et spacieuse. Sa texture naturelle et chaleureuse apporte une dimension authentique, tout en étant assez robuste pour supporter des années de projets créatifs. Avec ses finitions impeccables, ce plateau est non seulement pratique mais aussi une pièce élégante qui s’intègre parfaitement dans un atelier de couture ou un espace de vie.",
        "images": [
            "/images/table couture 2.jpg",
            "/images/table-de-couture---epicéa-massif/2.jpg"
        ]
    },
    {
        "src": "/images/présentoir-pour-épée---chêne-teinté-et-laiton/1.jpg",
        "title": "Présentoir pour épée - Chêne teinté et laiton",
        "tag": "Ce présentoir pour épée est une pièce artisanale en bois d'une belle teinte dorée, conçue pour un affichage horizontal. Ses supports incurvés et élégants sont sculptés pour épouser la forme de la garde et de la lame, tandis que la base ajourée et rehaussée d'un liseré de laiton assure une stabilité parfaite. C'est le support idéal pour mettre en valeur une pièce d'exception.",
        "images": [
            "/images/présentoir-pour-épée---chêne-teinté-et-laiton/1.jpg",
            "/images/présentoir-pour-épée---chêne-teinté-et-laiton/2.jpg",
            "/images/présentoir-pour-épée---chêne-teinté-et-laiton/3.jpg"
        ]
    }
];
